/* eslint-disable no-unused-vars */
export enum DialogType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  CONFIRM = 'confirm',
}

export type ModalDialogType =
  | DialogType.SUCCESS
  | DialogType.WARNING
  | DialogType.ERROR
  | DialogType.INFO
  | DialogType.CONFIRM;
